/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для оверлея.
   */
  app.OverlayView = app.View.extend({
    el: '.overlay-blue',
    
    events: {
      'click': 'overlayClose'
    },
    /**
     * Закрытие оверлея.
     */
    overlayClose: function () {
      this.trigger('overlayClose');
    }
  });
})();

}.call(window));